import { render } from "./DetailLogs.vue?vue&type=template&id=2efe0840"
import script from "./DetailLogs.vue?vue&type=script&lang=js"
export * from "./DetailLogs.vue?vue&type=script&lang=js"

import "./DetailLogs.vue?vue&type=style&index=0&id=2efe0840&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/logs/DetailLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2efe0840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2efe0840', __exports__)) {
    console.log('reload')
    api.reload('2efe0840', __exports__)
  }
  
  module.hot.accept("./DetailLogs.vue?vue&type=template&id=2efe0840", () => {
    console.log('re-render')
    api.rerender('2efe0840', render)
  })

}


export default __exports__